import React from 'react';
import AuthStore from 'stores/AuthStore';
import {sumBy} from 'utils/sum';
import {RepProfileAndName} from 'components/coaching/landing-pages/helpers/ProfileAndName';
import UserAvatar from 'components/pure/utils/UserAvatar';
import {toHHMM} from 'components/dashboard/admin/admin-coaching-meetings';
import {ImprovementMetricDisplay} from 'components/dashboard/admin/admin-coaching-meetings/components/ImprovementMetricDisplay';
import {SquaredOffMiniBar} from 'components/dashboard/admin/admin-coaching-meetings/components/SquaredOffMiniBar';
import './MeetingCategoryTooltip.styl';
import round from 'utils/round';
import ScrollAlerter from 'utils/scrolling/ScrollAlerter';
import classNames from 'classnames';

export class MeetingCategoryTooltip extends React.Component {
  state = {
    addScrollbarPadding: false,
  };

  onScrollAppear = () => {
    this.setState({addScrollbarPadding: true});
  };

  onScrollDisappear = () => {
    this.setState({addScrollbarPadding: false});
  };

  render() {
    const {
      meetingCategories,
      users,
      userCoachingBreakdown,
      improvementBreakdown,
      scoringBreakdown,
      fromPath,
    } = this.props;
    const {addScrollbarPadding} = this.state;
    const sessionUser = AuthStore.getState().user;

    // bars will be relative to the max bar length
    // save max & totals off just to make it easier later
    const meetingTimePerRep = userCoachingBreakdown.map(v => sumBy(v, i => i.value));
    const maxMeetingTime = meetingTimePerRep.max() || 0;

    const usersInOrder = meetingTimePerRep.sort().reverse().keySeq();

    return (
      <div className="meeting-category-tooltip">
        <div className="tooltip-wrapper">
          <header>
            <div className="header">Coaching Meetings By Recipient</div>
            <div
              className={classNames('metrics-labels', addScrollbarPadding && 'scrollbar-padding')}>
              <div>Time</div>
              <div>Avg. Score</div>
              <div>Score Improv.</div>
            </div>
          </header>
          <ScrollAlerter
            className="user-list"
            onScrollAppear={this.onScrollAppear}
            onScrollDisappear={this.onScrollDisappear}
            maxHeight={300}>
            {usersInOrder
              .map(userId => {
                const totalMeetingTime = meetingTimePerRep.get(userId);
                const categoryStats = userCoachingBreakdown.get(userId);
                const user = users.get(userId);
                const improvement = improvementBreakdown.get(userId);
                const avgScore = scoringBreakdown.get(userId);

                if (!user) {
                  console.warn('unable to find metadata for user', userId);
                }

                return (
                  <div className="row" key={userId}>
                    <div className="row-label">
                      {user ? (
                        <RepProfileAndName
                          rep={user}
                          adminId={sessionUser.id}
                          fromPath={fromPath}
                          tooltipEnabled={false}
                        />
                      ) : (
                        <div className="coaching-profile-container disabled">
                          <UserAvatar tooltipEnabled={false} />
                          <span className="linked">Deleted User</span>
                        </div>
                      )}
                    </div>
                    <div className="bar-area">
                      {categoryStats.map(cs => {
                        const category = meetingCategories.get(parseInt(cs.context, 10));

                        return (
                          <SquaredOffMiniBar
                            key={cs.context}
                            category={category}
                            metric={cs}
                            maxMeetingTime={maxMeetingTime}
                          />
                        );
                      })}
                    </div>
                    <div className="metrics">
                      <div className="total">{toHHMM(totalMeetingTime)}</div>
                      <div className="avg-score">
                        {avgScore === null || avgScore === undefined
                          ? 'N/A'
                          : round(improvement, 2) + '%'}
                      </div>
                      <ImprovementMetricDisplay improvement={improvement} className="improvement" />
                    </div>
                  </div>
                );
              })
              .toList()}
          </ScrollAlerter>
        </div>
      </div>
    );
  }
}
